import { useTheme } from "@mui/material";
import { useSelector } from "react-redux";
import type { RootState } from "../store/Index";
import { tokens } from "../theme";
import type { IColorTokens } from "../types/theme";

/**
 * Returns the company theme palette (from Redux) already resolved for the
 * current MUI mode. Use this instead of reading `state.theme.primary_colors`
 * directly — those arrays hold the LIGHT-mode palette only, so referencing
 * them in dark mode produces white-on-dark bugs.
 *
 * Equivalent to:
 *   const theme = useTheme();
 *   const reduxTheme = useSelector(s => s.theme);
 *   const colors = tokens(theme.palette.mode, reduxTheme);
 */
export const useThemeColors = (): IColorTokens => {
  const theme = useTheme();
  const reduxTheme = useSelector((state: RootState) => state.theme);
  return tokens(theme.palette.mode, reduxTheme);
};
